export const collegeClubs = [
  {
    id: 1,
    title: "President",
    organization: "Chess Club",
    startDate: "2021-03-01",
    endDate: "2023-06-01",
    logo: "/images/Education/exco-chess-2.svg",
    bullets: [
      "Coordinated bi-weekly chess tournaments on chess.com",
      "Managed club budget and coordinated fundraising events", 
      "Mentored new players and taught chess fundamentals to beginners",
    ]
  },
  {
    id: 3,
    title: "Vice President",
    organization: "Caribbean Student Society",
    startDate: "2021-01-01",
    endDate: "2021-12-31",
    logo: "/images/Education/exco-island.svg",
    bullets: [
      "Organized social events for Caribbean students on campus",
      "Managed social media presence and promotional materials for club activities",
      "Hosted Microsoft Teams Meetings during the pandemic",
    ]
  },
  {
    id: 2,
    title: "Member",
    organization: "KalamAfrica",
    startDate: "2020-09-01",
    endDate: "2023-06-01",
    logo: "/images/Education/exco-africa.svg",
    bullets: [
      "Participated in cultural awareness events and African heritage celebrations",
      "Assisted in organizing the annual Afro-Fiesta-Desi-Sol (AFDS) cultural festival",
      "Brought good vibes to weekly meetings 😅",
    ]
  },
  {
    id: 4,
    title: "Member",
    organization: "Intramural Soccer",
    startDate: "2022-09-01",
    endDate: "2023-06-01",
    logo: "/images/Education/Intramural-Soccer.svg",
    bullets: [
      "Played intramural soccer games with other students on campus",
    ]
  }
];